<template>
  <div class="news">
    <div class="asside">
      <img src="../../assets/images/ourStory/aside.png" alt="">
    </div>
    <div class="newsContent">
      <div class="title">NEWS</div>
      <img src="../../assets/images/ourStory/news.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "news",
  data() {
    return {
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.news{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .newsContent{
    .title{
      font-size: 34px;
      font-weight: 500;
      border-bottom: 3px solid #000000;
    }
    img{
      margin-top: 30px;
    }
  }
}
</style>